class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm ) return;
		const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          }
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);

/* Cart recommendation quantity selector - +/- to change quantity */
class CartRecommendationQuantity extends HTMLElement {
	connectedCallback(){
		if ( this._qtyInit ) return;
		const init = ()=>{
			if ( this._qtyInit ) return;
			const minus = this.querySelector('.cart-recommendation-qty-minus');
			const plus = this.querySelector('.cart-recommendation-qty-plus');
			this._valueEl = this.querySelector('.cart-recommendation-qty-value');
			if ( minus && plus && this._valueEl ) {
				this._qtyInit = true;
				minus.addEventListener('click', this._onMinus.bind(this));
				plus.addEventListener('click', this._onPlus.bind(this));
			}
		};
		init();
		if ( ! this._qtyInit ) requestAnimationFrame(init);
	}

	_onMinus(){
		if ( ! this._valueEl ) return;
		const qty = Math.max(0, parseInt(this._valueEl.textContent, 10) - 1);
		this._updateQty(qty);
	}

	_onPlus(){
		if ( ! this._valueEl ) return;
		const qty = parseInt(this._valueEl.textContent, 10) + 1;
		this._updateQty(qty);
	}

	_updateQty(newQty){
		const cartKey = this.dataset.cartKey;
		const cartLine = this.dataset.cartLine;
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm || ! cartForm.updateCartQty ) return;
		let cartItem = null;
		if ( cartKey ) {
			const items = cartForm.querySelectorAll('[data-js-cart-item]');
			for ( const it of items ) {
				if ( it.dataset.id === cartKey ) { cartItem = it; break; }
			}
		}
		if ( ! cartItem && cartLine ) {
			cartItem = cartForm.querySelector(`[data-js-cart-item][data-line="${cartLine}"]`);
		}
		if ( ! cartItem ) {
			if ( this.dataset.quickAddRef ) {
				const quickAdd = this.nextElementSibling;
				if ( quickAdd && quickAdd.matches('quick-add-to-cart') ) {
					quickAdd.style.display = '';
					this.remove();
				}
			} else {
				const productItem = this.closest('.product-item');
				const productLink = productItem && productItem.querySelector('a[href*="/products/"]');
				if ( productLink ) {
					const addLink = document.createElement('a');
					addLink.href = productLink.href;
					addLink.className = 'quick-add-to-cart';
					addLink.innerHTML = '<span class="text-size--small">' + ((KROWN.settings.locales && KROWN.settings.locales.products_add_to_cart_button) || 'Add to cart') + '</span>';
					this.replaceWith(addLink);
				}
			}
			return;
		}
		this._valueEl.textContent = newQty;
		cartForm.updateCartQty(cartItem, newQty);
		if ( newQty === 0 && this.dataset.quickAddRef ) {
			setTimeout(()=>{
				const quickAdd = this.nextElementSibling;
				if ( quickAdd && quickAdd.matches('quick-add-to-cart') ) {
					quickAdd.style.display = '';
					this.remove();
				}
			}, 600);
		}
	}
}
customElements.define('cart-recommendation-quantity', CartRecommendationQuantity);